exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * React App SDK (https://github.com/kriasoft/react-app)\n *\n * Copyright © 2015-present Kriasoft, LLC. All rights reserved.\n *\n * This source code is licensed under the MIT license found in the\n * LICENSE.txt file in the root directory of this source tree.\n */\n\n.p5_canvasWrapper_1ju > canvas{\n  position: absolute;\n  left: 0;\n  top: 0;\n\n  /* transform: translate(050%, 0px); */\n}\n", "", {"version":3,"sources":["/./routes/Home/p5.css"],"names":[],"mappings":"AAAA;;;;;;;GAOG;;AAEH;EACE,mBAAmB;EACnB,QAAQ;EACR,OAAO;;EAEP,sCAAsC;CACvC","file":"p5.css","sourcesContent":["/**\n * React App SDK (https://github.com/kriasoft/react-app)\n *\n * Copyright © 2015-present Kriasoft, LLC. All rights reserved.\n *\n * This source code is licensed under the MIT license found in the\n * LICENSE.txt file in the root directory of this source tree.\n */\n\n.canvasWrapper > canvas{\n  position: absolute;\n  left: 0;\n  top: 0;\n\n  /* transform: translate(050%, 0px); */\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"canvasWrapper": "p5_canvasWrapper_1ju"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":true,"modules":true,"localIdentName":"[name]_[local]_[hash:base64:3]","minimize":false}!./~/postcss-loader!./routes/Home/p5.css
// module id = 261
// module chunks = 0